module.exports = __webpack_public_path__ + "img/object_headphones_1.96529d76.png";